module.exports = __webpack_public_path__ + "img/logo-blanc-widddi.d1571c30.svg";